<template>
  <v-skeleton-loader :loading="loading" transition="scale-transition" type="table-tbody">
    <v-card class="mx-auto">
      <v-card-title>Chronic Conditions</v-card-title>
      <v-card-text>
        <pie-chart
          :data="chartDataConditions"
          :options="options"
          :styles="chartStyles"
          :chart="'chronic'"
        />
      </v-card-text>
    </v-card>
  </v-skeleton-loader>
</template>

<script>
import axios from 'axios';
import { debounce } from 'lodash';
import PieChart from '../charts/piechart';

// import BarChart from '../charts/BarChart';å

export default {
  components: {
    PieChart,
    // BarChart,
  },
  props: [
    'insurance',
    'group',
    'providers',
    'locations',
    'startDate',
    'endDate',
    'forProviderModal',
  ],
  data() {
    return {
      chartConditions: [],
      chartValues: [],
      chartDataConditions: {},
      chartInfo: [],
      chartColors: [],
      defaultColors: {
        rgb: [
          'rgba(51, 188, 218, 0.3)',
          'rgba(236, 64, 122, 0.3)',
          'rgba(30, 136, 229, 0.3)',
          'rgba(225, 84, 84, 0.3)',
          'rgba(255, 161, 102, 0.3)',
          'rgba(59, 178, 115, 0.3)',
          'rgba(119, 104, 174, 0.3)',
        ],
        hex: ['#33bcda', '#ec407a', '#1e88e5', '#e15554', '#ffa166', '#3bb273', '#7768ae'],
      },
      // lineColor: '#ec407a',
      loading: false,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          labels: {
            padding: 30,
          },
          position: 'bottom',
          // display: false
        },
      },
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData: debounce(async function getData() {
      this.loading = true;
      const start = this.startDate;
      const end = this.endDate;
      const ins = this.insurance;
      const { group } = this;
      const pro = this.providers;
      const loc = this.locations;

      const provNum = [];
      if (pro.length > 0) {
        pro.forEach((prov) => {
          if (provNum.indexOf(prov.PROVIDER_ID) === -1) {
            provNum.push(prov.PROVIDER_ID);
          }
        });
      }

      const locAddress = [];
      if (loc.length > 0) {
        loc.forEach((loca) => {
          if (locAddress.indexOf(loca.PROVIDER_LOCATION) === -1) {
            locAddress.push(loca.PROVIDER_LOCATION);
          }
        });
      }

      const url = `api/chronicChart/group=${group}/${ins}/provider=${provNum}/location=${locAddress}/start=${start}/end=${end}`;
      axios.get(url).then((response) => {
        this.loading = false;
        this.chartConditions = [];
        this.chartValues = [];
        this.chartInfo = [];
        this.chartColors = [];

        this.chartInfo = response.data;
        response.data.forEach((info, i) => {
          this.chartColors.push(this.defaultColors.hex[i]);
          this.chartConditions.push(info.DIAGNOSIS);
          this.chartValues.push(info.COUNT);
        });
      });
    }, 500),

    chartData() {
      this.chartDataConditions = {
        labels: this.chartConditions,
        datasets: [
          {
            label: 'Chronic Conditions',
            data: this.chartValues,
            borderAlign: 'inner',
            backgroundColor: this.defaultColors.rgb,
            borderColor: this.defaultColors.hex,
            borderWidth: 3,
            borderRadius: 3,
          },
        ],
      };
    },
  },
  computed: {
    chartStyles() {
      return {
        height: '20em',
      };
    },
  },
  watch: {
    startDate: {
      immediate: true,
      handler() {
        this.getData();
      },
    },
    endDate: {
      immediate: true,
      handler() {
        this.getData();
      },
    },
    insurance: {
      immediate: true,
      handler() {
        this.getData();
      },
    },
    group: {
      immediate: true,
      handler() {
        this.getData();
      },
    },
    providers: {
      immediate: true,
      handler() {
        this.getData();
      },
    },
    locations: {
      immediate: true,
      handler() {
        this.getData();
      },
    },
    chartValues() {
      this.chartData();
    },
  },
};
</script>
